import { inject } from '@angular/core';
import { LeadCampaignApiService } from '@shared/services';
import { PERMISSIONS } from '@shared/constants';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const leadCampaignTableConfig = (): TableConfig => {
  const leadCampaignApiService = inject(LeadCampaignApiService);

  return {
    title: 'Danh sách Lead Campaigns',
    entityName: 'lead-campaign',
    service: leadCampaignApiService,
    method: 'getLeadCampaigns',
    columns: [
      { field: 'code', header: 'Mã', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'name', header: 'Tên', width: 'min-w-[200px]', sortable: true, type: 'text' },
      { field: 'date', header: 'Ngày', width: 'min-w-[150px]', sortable: true, type: 'date' },
    ],
    features: {
      virtualScroll: true,
      toolbar: true,
      selection: {
        mode: 'multiple',
        metaKeySelection: false,
        dataKey: 'id'
      }
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        permission: PERMISSIONS.LEAD_CREATE.code,
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        permission: PERMISSIONS.LEAD_UPDATE.code,
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      },
      {
        location: 'row',
        useDefaultStyle: 'delete',
        permission: PERMISSIONS.LEAD_DELETE.code,
        confirmMessage: 'Bạn có chắc chắn muốn xóa campaign này?',
        onClick: PLACEHOLDER_FUNCTIONS.DELETE
      }
    ]
  };
};

